import { useQuery } from '@tanstack/react-query';
import { supabase } from 'sdk/api';

export async function getOTOAccessToken() {
  const url = 'https://api.tryoto.com/rest/v2/refreshToken';
  const body = {
    refresh_token:
      'AMf-vByfREzts1VVd0-_HHiT-TCOInPymKlFU9W1pqTUDQocrPOQ2lzoIZvQqOd494VnKZwNncNePH7V_5CSLwc3fazemQ2EXkHPMJ06qahMLpNRnQc9lJ-bXY4ZbweuXF1gdb8GILerN7Hmbqh4nuz520Tzp1xskCoGsW07t5A-ZmLcJBCX_U1cKsfCuxNcENp7mKyU7QRHx9qCP1bHF1PyqqK1Wm9W9Q',
  };

  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }).then(res => res.json());

  return response;
}

const getOrders = async (id, productId) => {
  const { data, error } = await supabase.from('orders').select('*').eq('transaction_id', id);

  if (error) {
    throw new Error(`Error fetching transaction: ${error.message}`);
  }

  const ids = data?.map(item => item?.id);

  const { data: orderItems } = await supabase
    .from('order_items')
    .select('*')
    .in('order_id', ids)
    .eq('product', productId);

  return orderItems;
};

export default function useGetOrders(id, productId) {
  return useQuery({
    queryKey: ['useGetOrders', id, productId],
    queryFn: () => getOrders(id, productId),
    staleTime: 0,
    enabled: !!id,
  });
}
